// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"071b33ff","136":"98042df2","157":"cf4cfffc","192":"c7e664b3","275":"6001fb80","292":"20f81d7a","401":"a6e67adc","453":"f564965c","654":"d58f9731","673":"d02b7fa6","771":"8ed9dc8f","782":"7a8bbac1","950":"4c9da984","977":"bf858366","985":"f5c4025a"}[chunkId] + ".chunk.js";
};